<template lang="pug">
.content-wrap
  .content-top
    .con
      .gbox-wrap.overflow-hidden
        .news-list-wrap.text-white
          .news-listbox
            .iimg
              img(src="/new/img/article/htcrp2026.png")
            .ccon
              div Online Slot Casino Malaysia: How to Choose the Right Platform (2026 Guide)
              div
                p Why This Online Slot Casino Malaysia Guide Exists
                p Spend a few minutes searching for slot casino online Malaysia and a clear pattern appears. Many pages focus on promotions, highlight large bonus figures, and encourage quick registration.
              router-link.btn-submit.mt-2(to="/online-slot-casino-malaysia") {{$t('ui.read_more')}} >>
          .news-listbox
            .iimg
              img(src="/new/img/article/topcasinoapril2026.png")
            .ccon
              div Top Casino Malaysia For April 2026
              div
                p
                | Looking for the 
                strong best online casinos in Malaysia
                |  this April? We've analyzed and ranked the top platforms offering the most generous
                strong  RM50 No Deposit Bonuses
                |  and exclusive free credits for Malaysian players.
              router-link.btn-submit.mt-2(to="/news/top-casino-malaysia-april-2026") {{$t('ui.read_more')}} >>
          .news-listbox(v-for="news in newsList")
            .iimg
              img(:src="imgUrl+news.en_image_url")
            .ccon
              div(v-html="news.en_title")
              div(v-html="news.en_preview_body")
              router-link.btn-submit.mt-2(:to="'/news/'+news.slug") {{$t('ui.read_more')}} >>
      footerInfo(:target="'/news'")
</template>
<script>
import config from "@/config";
import topbar from '@/views/default/_topBar.vue'
import footerInfo from '@/views/default/_footerArticle.vue'
export default {
  components:{
    topbar,
    footerInfo
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
			loading:false,
      newsList:[],
      imgUrl: config.imageUrl,
    }
  },
  created(){
    window.scroll(0,0)
    $('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/news`);
		// this.getSeo("news")
    this.getNewsList()
	},
  mounted(){
  },
  methods:{
    getSeo(page){
      let page_name = page
      this.$store
        .dispatch("user/getSeo", {page_name})
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
						}
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
    },
    getNewsList(){
      var lang = "en"
      this.$store
        .dispatch("user/getNewsList",{lang})
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
            this.newsList = response.data
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
    }
  }
}
</script>